import React, { createContext, useContext, useState } from 'react'

interface HealthAlertNotificationType {
  healthAlertNotification: any[]
  setHealthAlertNotification: React.Dispatch<React.SetStateAction<any[]>>
}

const HealthAlertNotificationContext = createContext<HealthAlertNotificationType | undefined>(undefined)

export const HealthAlertNotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [healthAlertNotification, setHealthAlertNotification] = useState<any[]>([])
  return (
    <HealthAlertNotificationContext.Provider value={{ healthAlertNotification, setHealthAlertNotification }}>
      {children}
    </HealthAlertNotificationContext.Provider>
  )
}

export const useHealthAlertNotification = (): HealthAlertNotificationType => {
  const context = useContext(HealthAlertNotificationContext)
  if (!context) throw new Error('useHealthAlertNotification must be used within a HealthAlertNotificationProvider')
  return context
}
